import Vue from 'vue'
import App from './App.vue'
import router from './router'
import sendAnalytics from './assets/js/alytics'
import './assets/css/reset.scss'


Vue.config.productionTip = false
Vue.prototype.$sendAnalytics = sendAnalytics

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
